import { DELETE, GET, PATCH, POST, POST_FILE } from '../common/common.service'
import endpointsOwnCenters from './endpoints'

const OwnCentersServices = {
  getAll: async ({ filter, sort, limit, skip }) =>
    GET(endpointsOwnCenters.LOAD(filter, sort, limit, skip)),
  getById: async (id) => GET(endpointsOwnCenters.BY_ID(id)),
  create: async (body) => POST(endpointsOwnCenters.CREATE, body),
  update: async ({ id, body }) => PATCH(endpointsOwnCenters.BY_ID(id), body),
  remove: async (id) => DELETE(endpointsOwnCenters.BY_ID(id)),
  getProvinces: async () => GET(endpointsOwnCenters.PROVINCES),
  services: {
    getServices: async (id) => GET(endpointsOwnCenters.SERVICES(id)),
    updateServices: async (id, body) =>
      PATCH(endpointsOwnCenters.SERVICES(id), body),
  },
  technical: {
    getTechnical: async (id) => GET(endpointsOwnCenters.TECHNICAL(id)),
    updateTechnical: async (id, body) =>
      PATCH(endpointsOwnCenters.TECHNICAL(id), body),
  },
  courts: {
    getAllCourts: async ({ id, filter, sort, limit, skip }) =>
      GET(endpointsOwnCenters.COURTS.LOAD(id, filter, sort, limit, skip)),
    getCourt: async (centerId, id) =>
      GET(endpointsOwnCenters.COURTS.BY_ID(centerId, id)),
    addCourt: async (id, body) =>
      POST(endpointsOwnCenters.COURTS.COURT(id), body),
    updateCourt: async ({ _id, body }) =>
      PATCH(endpointsOwnCenters.COURTS.BY_ID(_id, body._id), body),
    removeCourt: async (centerId, id) =>
      DELETE(endpointsOwnCenters.COURTS.BY_ID(centerId, id)),
  },
  vacuum: {
    getAllVacuumCleaners: async ({ id, filter, sort, limit, skip }) =>
      GET(
        endpointsOwnCenters.VACUUM_CLEANERS.LOAD(id, filter, sort, limit, skip),
      ),
    getVacuumCleaner: async (centerId, id) =>
      GET(endpointsOwnCenters.VACUUM_CLEANERS.BY_ID(centerId, id)),
    addVacuumCleaner: async (id, body) =>
      POST(endpointsOwnCenters.VACUUM_CLEANERS.VACUUM_CLEANER(id), body),
    updateVacuumCleaner: async ({ _id, body }) =>
      PATCH(endpointsOwnCenters.VACUUM_CLEANERS.BY_ID(_id, body._id), body),
    removeVacuumCleaner: async (centerId, id) =>
      DELETE(endpointsOwnCenters.VACUUM_CLEANERS.BY_ID(centerId, id)),
  },
  other_data: {
    getAllOtherData: async ({ id, filter, sort, limit, skip }) =>
      GET(endpointsOwnCenters.OTHER_DATA.LOAD(id, filter, sort, limit, skip)),
    addOtherData: async (id, body) =>
      POST(endpointsOwnCenters.OTHER_DATA.OTHER_DATA(id), body),
    updateOtherData: async ({ _id, body }) =>
      PATCH(endpointsOwnCenters.OTHER_DATA.BY_ID(_id, body._id), body),
    removeOtherData: async (centerId, id) =>
      DELETE(endpointsOwnCenters.OTHER_DATA.BY_ID(centerId, id)),
  },
  manuals: {
    getAllManuals: async ({ id, filter, sort, limit, skip }) =>
      GET(endpointsOwnCenters.MANUALS.LOAD(id, filter, sort, limit, skip)),
    addManual: async (id, body) =>
      POST(endpointsOwnCenters.MANUALS.BY_CENTER(id), body),
    uploadManual: async (id, manualId, body) =>
      POST_FILE(endpointsOwnCenters.MANUALS.UPLOAD(id, manualId), body),
    removeManual: async (centerId, id) =>
      DELETE(endpointsOwnCenters.MANUALS.BY_ID(centerId, id)),
  },
  external_companies: {
    getAllExternalCompanies: async ({ id, filter, sort, limit, skip }) =>
      GET(
        endpointsOwnCenters.EXTERNAL_COMPANIES.LOAD(
          id,
          filter,
          sort,
          limit,
          skip,
        ),
      ),
    addExternalCompanies: async (id, body) =>
      POST(endpointsOwnCenters.EXTERNAL_COMPANIES.BY_CENTER(id), body),
    updateExternalCompanies: async ({ _id, body }) =>
      PATCH(endpointsOwnCenters.EXTERNAL_COMPANIES.BY_ID(_id, body._id), body),
    removeExternalCompanies: async (centerId, id) =>
      DELETE(endpointsOwnCenters.EXTERNAL_COMPANIES.BY_ID(centerId, id)),
  },
  getEmployees: async ({ id, filter, sort, limit, skip }) =>
    GET(endpointsOwnCenters.EMPLOYEES(id, filter, sort, limit, skip)),
}

export default OwnCentersServices
